import React from 'react'
import {Row, Col} from 'react-bootstrap';

// Alternate success page to be shown when a Lead Service Line Inventory template is uploaded
const FileUploadSuccessLSL = () => {
    return (
        <>
        <Row>
            <Col>
                <p>Thank you for uploading your Lead Service Line Inventory template. Your file will be validated,
                    and you will receive an email soon with the results of the validation.</p>
                <p>If any errors are found, the email you receive will inform you what needs to be fixed,
                    and you will need to upload a corrected file. If there are no errors, your file will be reviewed
                    by a staff member.</p>
            </Col>
        </Row>
        </>
    )
}

export default FileUploadSuccessLSL;